/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Typography from '@digital-hig/mui/dist/Typography';
// import { Link } from 'react-router-dom';
import DOMPurify from 'isomorphic-dompurify';
import ComboBox from '@digital-hig/mui/dist/Combobox';
import window from 'global/window';
import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import SvgIcon from '@mui/material/SvgIcon';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import CheckIcon from '@digital-hig/icon/lib/esm/icons/checkmark';
import SvgCtaArrowRight from '@digital-hig/icon/lib/esm/icons/cta-arrow-right';
import {
  getEditorialData, getProductList, getSelectedProduct, setSelectedProduct,
} from '../store/indexSlice';
import { triggerSearchRefinement } from '../common/analyticsApi';
import {
  styleVariables, EDC_SLUG_INDEX_SELECT_PRODUCT,
} from '../common/constants';
import { getChildProperty } from '../common/object';

const SoftwareSelector = ({ showFreeTrial }) => {
  const dispatch = useDispatch();
  const productList = useSelector(getProductList);
  const productSelected = useSelector(getSelectedProduct);
  const indexData = useSelector(getEditorialData);

  const productListOptions = productList?.map((product) => ({
    label: product.text, value: product.value, guid: product.guid,
  })) || [];

  useEffect(() => {
    const hash = `#${productSelected?.guid}`;
    if (!productSelected?.guid || window?.location.hash !== hash) {
      const product = productList?.find((prod) => `#${prod.guid}` === window?.location.hash);
      if (product) {
        dispatch(setSelectedProduct(product));
      }
    }
  }, [productList, productSelected]);

  useEffect(() => {
    if (productSelected?.guid && window?.location?.hash !== `#${productSelected?.guid}`) {
      window.history.replaceState(null, '', `#${productSelected?.guid}`);
    }
  }, [productSelected]);

  return (
    <RootElement>
      <Typography
        component="p"
        color="ink-on-background"
        sx={{ maxWidth: '860px' }}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(getChildProperty(indexData, `${EDC_SLUG_INDEX_SELECT_PRODUCT}.content`)) }}
      />
      <div className="search-with-start-trial">
        <FormControl style={{ width: '300px' }}>
          <InputLabel htmlFor="selectProduct">Software</InputLabel>
          <ComboBox
            id="selectProduct"
            placeholder="Select..."
            options={productListOptions}
            defaultValue={productListOptions.find((option) => {
              if (window?.location?.hash) {
                return `#${option?.guid}` === window?.location?.hash;
              }

              return option?.guid === productSelected?.guid;
            })}
            renderOption={(props, option, state) => (
            // eslint-disable-next-line react/jsx-props-no-spreading
              <MenuItem key={option.value} value={option.value} {...props}>
                <div
                  style={{ display: 'flex', width: '100%' }}
                >
                  <div
                    style={{
                      flex: 1,
                      marginRight: '1.5rem',
                    }}
                  >
                    {option.label}
                  </div>
                  <div
                    style={{ width: '15px' }}
                  >
                    {state.selected && (
                      <SvgIcon
                        title="Selected"
                        className="DhigCombobox--checkedIcon"
                        style={{ float: 'right' }}
                      >
                        <CheckIcon />
                      </SvgIcon>
                    )}
                  </div>
                </div>
              </MenuItem>
            )}
            onChange={(e, option) => {
              if (option) {
                window?.history.replaceState(null, '', `#${option?.guid}`);
                dispatch(setSelectedProduct(productList?.find((prod) => prod.value === option.value)));
                triggerSearchRefinement({
                  result: {
                    filters: [{
                      label: 'Software',
                      selections: [{ text: option?.label, guid: option?.guid, selected: true }],
                    }],
                  },
                });
              } else {
                window?.history.replaceState(null, '', '#');
                dispatch(setSelectedProduct({}));
              }
            }}
          />
        </FormControl>
        {
          (productSelected?.guid && showFreeTrial)
            ? (
              <div>
                <CardActions className="start-trial-wrapper">
                  <Typography variant="headline-smaller">
                    Ready to start exploring
                    {' '}
                    {productSelected?.value}
                    ?
                  </Typography>
                  <Button
                    variant="link-button"
                    startIcon={<SvgIcon><SvgCtaArrowRight /></SvgIcon>}
                    sx={{ marginLeft: '0px !important' }}
                    href="/free-trials"
                    data-testid="free-trial-cta"
                    data-wat-linkname={`Start your trial today ${productSelected?.value}`}
                  >
                    <Typography component="span" variant="button-label-dense">Start your trial today</Typography>
                  </Button>
                </CardActions>
              </div>
            ) : null
        }
      </div>
    </RootElement>
  );
};

const RootElement = styled.div`
        .search-with-start-trial {
        display: flex;
        flex-direction: row;
        gap: 48px;
        align-items: center;
        margin-top: 48px;
  
      }
      .start-trial-wrapper {
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 8px;
        padding: 0px !important;
        padding-left: 32px !important;
        border-left: 1px solid ${styleVariables.lightDivider}
      }

      @media only screen and (max-width: 560px) {
  
        .search-with-start-trial {
          display: flex;
          flex-direction: column;
          align-items: start;
          gap: 32px;
        }
    
        .start-trial-wrapper {
          padding: 0px !important;
          border: none;
        }
      }
`;

SoftwareSelector.propTypes = {
  showFreeTrial: PropTypes.bool,
};
SoftwareSelector.defaultProps = {
  showFreeTrial: true,
};

export default SoftwareSelector;
